<template>
    <div class="block">
        <div class="loginlogo">
            <van-image width="50%" :src="VUE_APP_LOGIN_LOGO_URL" />
            <p style="font-size:18px;color: darkgray" @click="clearSession()">提货服务平台</p>
            <div class="loginbar">
                <van-form>
                    <van-field style="font-size: 16px;"
                               v-model="username"
                               name="username"
                               left-icon="phone-o"
                               label=" "
                               label-width="5px"
                               placeholder="请输入手机号码"
                    />
                    <van-field style="font-size: 16px"
                               v-model="smsCode"
                               type="number"
                               name="smsCode"
                               left-icon="comment-o"
                               label=" "
                               label-width="5px"
                               placeholder="请输入验证码"
                    >
                        <template #button>
<!--                            <van-button  size="normal" type="default" :disabled="buttonStatus" >{{buttonTxt}}</van-button>-->
                            <a style="color: #6685a4;margin-right: 6px" :disable="smstime==0?false:true" @click="sendMsg()">{{buttonTxt}}</a>
                        </template>
                    </van-field>
                    <div style="margin: 16px;">
                        <van-button color="#6685a4" block type="info" native-type="submit" style="font-size: 16px" @click="newlogin()">
                            登录
                        </van-button>
                    </div>
                </van-form>
            </div>
            <div class="userbiz">
                <span @click="register()">驾驶员注册</span>
            </div>
<!--            <div class="agreewarp">-->
<!--                <van-checkbox  v-model="checked"  shape="square"  checked-color="#6685a4">登录表示同意<a @click.stop="showAgreement()">《用户协议》</a></van-checkbox>-->
<!--            </div>-->

        </div>
        <!--        <div class="footer">-->
        <!--            Copyright©  2016-2020无锡云储科技有限公司<br/>-->
        <!--        </div>-->
        <van-overlay :show="show" @click="show">
            <div class="wrapper" @click.stop>
                <van-loading type="spinner" color="#1989fa" vertical><span style="color:#1989fa;font-weight: bolder">登录中..</span></van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import {Image as VanImage, Toast} from 'vant';
    import { Form } from 'vant';
    import { Field,Checkbox  } from 'vant';
    import { Button } from 'vant';
    import service from '../server/index'
    import { Dialog } from 'vant';
    import { Overlay } from 'vant';
    import { Loading } from 'vant';
    import qs from 'qs';

    export default {
        name: "Login",
        components:{
            [VanImage.name]: VanImage,
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]: Button,
            [Dialog.Component.name]: Dialog.Component,
            [Overlay.name]: Overlay,
            [Loading.name]: Loading,
            [Checkbox.name]:Checkbox,


        },
        data() {
            return {
                username: '',
                smsCode: '',
                buttonTxt:"获取验证码",
                buttonStatus:false,
                smstime:0,
                timer:-1,
                show: false,
                checked:true,
                clearSessionTime:0,
                VUE_APP_LOGIN_LOGO_URL:process.env.VUE_APP_LOGIN_LOGO_URL,
            };
        },
        created(){
            if(!this.getQueryString("code")&&!localStorage.getItem("code"))
            {
                let origin =  location.href;
                // localStorage.setItem("url",origin)
                let urlNow =encodeURIComponent(origin);///netbar/api/wechat/v1/get_open_id
                let scope = 'snsapi_userinfo';    //snsapi_userinfo   //静默授权 用户无感知
                let appid =  process.env.VUE_APP_APPID;
                let state = '1';
                let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`

                window.location.href=url;

                // alert('第一次进入'+url);

            }else if (!localStorage.getItem("code"))
            {
                // alert('第二次进入且路径存在code');
                localStorage.setItem("code",this.getUrlParme("code"));
                let paramCode = {
                    code:this.getUrlParme("code"),
                    appName:process.env.VUE_APP_NAME,
                    ouid:process.env.VUE_APP_WECHAT_OUID
                }
                // alert(this.getUrlParme("code"));
                service.getUeserOpenIdNew(qs.stringify(paramCode)).then(res=>{
                    // alert(res.data);
                    if(res.code==200){
                        // alert(res.data.openId)
                        localStorage.setItem('openId',res.data.openId);
                        localStorage.setItem('accessToken',res.data.accessToken);

                        let param={
                            openId:res.data.openId,
                            accessToken:res.data.accessToken
                        }
                        service.getWxUser(qs.stringify(param)).then(res=>{

                            if(res.code==200){
                                localStorage.setItem("userImage",res.data.headimgurl)
                                this.$router.replace('/thLogin');

                            }else{
                                Dialog.alert({
                                    title: '请求失败：'+res.msg,
                                })
                            }

                        }).catch(res=>{
                            console.log(res)
                            // alert(res);
                        })



                    }else{
                        Dialog.alert({
                            title: '错误提示',
                            message: res.msg,
                        }).then(() => {
                            // on close
                        });
                    }

                }).catch(res=>{
                    alert(res);
                })

            }
            else if (localStorage.getItem("openId"))
            {
                // alert("openid")
                if(localStorage.getItem('token'))
                {
                    // alert("tokenopenid")
                let param = {
                    openId:localStorage.getItem("openId"),
                    appName:process.env.VUE_APP_NAME
                }
                service.getDeliverUeserOpenId(qs.stringify(param)).then(res=>{
                    if(res.code==200){
                        localStorage.setItem("deliveryName",res.data.merchantInfo.deliveryName)
                        this.$store.dispatch("setToken",res.data.token);
                        this.$store.dispatch("setPersonName",res.data.merchantInfo.deliveryName);
                        this.$store.dispatch("setPhoneNumber",res.data.merchantInfo.phoneNumber);
                        this.$store.dispatch("setDeliveryIdnumber",res.data.merchantInfo.idnumber);
                        this.$store.dispatch("setDeliveryId",res.data.merchantInfo.deliveryUserId);
                        this.$router.replace("/thAll")

                    }else{
                        this.$router.replace('/thLogin');
                    }

                }).catch(res=>{
                    alert(res);
                })
                }
            }
        },
        methods:{
            newlogin() {
                this.show= true;

                if(this.username=="" || this.smsCode==""){
                    Dialog.alert({
                        title: '错误提示',
                        message: "手机号码或验证码不能为空",
                    }).then(() => {
                        this.show= false;
                    });
                    return ;
                }



                let param = {
                    phoneNumber:this.username,
                    smsCode:this.smsCode,
                    loginType:"wechat",
                    wxOpenid:localStorage.getItem("openId"),
                    headImgUrl:localStorage.getItem("userImage"),
                    appName:process.env.VUE_APP_NAME,
                    ouid:process.env.VUE_APP_WECHAT_OUID
                    // wxOpenid:"oSIwMuCmF5u9FBv8LZEbE_D48qXE",
                    // headImgUrl:"xxxxxxxxx",
                }
                service.doLoginwx(param).then(res=>{
                    if(res.code==200){
                        localStorage.setItem("deliveryName",res.data.merchantInfo.deliveryName)
                        this.$store.dispatch("setToken",res.data.token);
                        this.$store.dispatch("setPersonName",res.data.merchantInfo.deliveryName);
                        this.$store.dispatch("setPhoneNumber",res.data.merchantInfo.phoneNumber);
                        this.$store.dispatch("setDeliveryIdnumber",res.data.merchantInfo.idnumber);
                        this.$store.dispatch("setDeliveryId",res.data.merchantInfo.deliveryUserId);
                        this.$router.replace("/thAll")
                    }else{
                        Dialog.alert({
                            title: '错误提示',
                            message: res.msg,
                        }).then(() => {
                            // on close
                        });
                    }
                    this.show= false;
                }).catch(res=>{
                    console.log(res.message);
                    Dialog.alert({
                        title: '错误提示',
                        message: res.message,
                    }).then(() => {
                        // on close
                    });
                    this.show= false;
                })


            },

            login() {
                this.show= true;

                if(this.username=="" || this.smsCode==""){
                    Dialog.alert({
                        title: '错误提示',
                        message: "用户名或验证码不能为空",
                    }).then(() => {
                        this.show= false;
                    });
                    return ;
                }

                if(!this.checked){
                    Dialog.alert({
                        title: '错误提示',
                        message: "请同意用户协议",
                    }).then(() => {
                        this.show= false;
                    });
                    return ;
                }

                let param = {
                    username:this.username,
                    smsCode:this.smsCode,
                    systemId:55,
                    userType:30,
                    loginType:"wechat",
                    openId:localStorage.getItem("openId"),
                    userImage:"",
                    pre:'login'
                }
                service.login(qs.stringify(param)).then(res=>{
                    if(res.code==200){
                        this.$store.dispatch("setToken",res.data.tokenjwt);
                        this.$store.dispatch("setPersonName",res.data.personName);
                        this.$store.dispatch("setPhoneNumber",res.data.phoneNumber);
                        this.$store.dispatch("setDeliveryIdnumber",res.data.idnumber);
                        this.$store.dispatch("setDeliveryId",res.data.deliveryId);
                        this.$store.dispatch("setUserId",res.data.userId);
                        this.$store.dispatch("setPersonId",res.data.personId);
                        this.$router.replace("/")
                    }else{
                        Dialog.alert({
                            title: '错误提示',
                            message: res.msg,
                        }).then(() => {
                            // on close
                        });
                    }
                    this.show= false;
                }).catch(res=>{
                    console.log(res.message);
                    Dialog.alert({
                        title: '错误提示',
                        message: res.message,
                    }).then(() => {
                        // on close
                    });
                    this.show= false;
                })


            },
            getQueryString(name){
                let reg =new RegExp('(^|&)' + name + '=([^&]*)(&|$)','i');
                let r = window.location.search.substr(1).match(reg);
                if(r!=null)
                {
                    return unescape(r[2]);
                }
                return null;
            },
            getUrlParme(parameName){
                let parames=window.location.search
                if(parames.indexOf(parameName) > -1 )
                {
                    let parameValue = parames.substring(parames.indexOf(parameName),parames.length)
                    if(parameValue.indexOf('&') > -1)
                    {
                        parameValue = parameValue.substring(0,parameValue.indexOf('&'))
                        parameValue = parameValue.replace(parameName + '=','')
                        return parameValue
                    }
                    return ''

                }
            },
            clearSession(){
                this.clearSessionTime++
                if(this.clearSessionTime==3){
                    let str = "code:"+window.localStorage.getItem('code');
                    str+="|"+"token:"+window.localStorage.getItem('token');
                    str+="|"+"personName:"+window.localStorage.getItem('personName');
                    str+="|"+"phoneNumber:"+window.localStorage.getItem('phoneNumber');
                    str+="|"+"deliveryIdnumber:"+window.localStorage.getItem('deliveryIdnumber');
                    str+="|"+"deliveryId:"+window.localStorage.getItem('deliveryId');
                    str+="|"+"userId:"+window.localStorage.getItem('userId');
                    str+="|"+"openId:"+window.localStorage.getItem('openId');
                    str+="|"+"url:"+window.localStorage.getItem('url');
                    alert(str);

                    Dialog.confirm({
                        title: '提示消息',
                        message: '确定要清除缓存吗？',
                        confirmButtonColor:"#6685a4"
                    })
                        .then(() => {
                            window.localStorage.removeItem('code');
                            window.localStorage.removeItem('token');
                            window.localStorage.removeItem('personName');
                            window.localStorage.removeItem('phoneNumber');
                            window.localStorage.removeItem('deliveryIdnumber');
                            window.localStorage.removeItem('deliveryId');
                            window.localStorage.removeItem('userId');
                            window.localStorage.removeItem('openId');
                            Toast('缓存清理完毕');
                            this.clearSessionTime=0;
                        })
                        .catch(() => {
                            // on cancel
                            this.clearSessionTime=0;
                        });

                }
            },
            register(){
                this.$router.replace("/RegisterDeliveryTh")
            },
            sendMsg(){
                let myreg = /^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[1,8,9])\d{8}$/;
                if (this.username == '') {
                    Toast('手机号码不能为空');
                    return false
                } else {
                    if (!myreg.test(this.username)) {
                        Toast('手机号码格式不正确');
                        return false
                    }

                }

                let param={
                    phoneNumber:this.username,
                    bussnissType:'deliverCode',
                    appName:process.env.VUE_APP_NAME
                }
                service.getThLoginCode(param).then(res=>{
                    if(res.code==200){
                        Toast('发送成功');
                        this.smstime=60;
                        this.buttonStatus=true;
                        this.timer = setInterval(() => {          //
                            this.smstime--;
                            this.buttonTxt=this.smstime+"秒后重试";
                            if(this.smstime <= 0) {
                                this.smstime = 0
                                this.buttonStatus=false;
                                this.buttonTxt="重新获取"
                                clearInterval(this.timer);
                            }
                            // if(this.smstime==10){
                            //     Toast('验证码:1');
                            // }
                        }, 1000)
                    }else{
                        Toast(res.msg);
                    }

                }).catch(res=>{
                    alert(res);
                })


            },
            showAgreement(){
                this.$router.replace("/Agreement")
            }
        }
    }
</script>

<style scoped lang="scss">

    .block{
        width: 100%;
        height:100vh;
        background-image: url('../assets/image/top.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .loginlogo{
        padding-top:100px;
    }
    .loginbar{
        width:90%;
        margin:50px auto 0px auto;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .userbiz{
        font-size: 16px;
        margin-top: 10px;
        text-align: center;
        color: #6685a4;
    }

    .agreewarp{
        font-size: 14px;
        text-align: center;
        width: 200px;
        margin: 50px auto;
        a{
            color: #6685a4;
        }

        left: 0;
        right: 0;
        height: 30px;

    }



    .footer{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 60px;
        font-size: 12px;
    }

</style>
